import s from './styles.scss';
import cx from 'classnames';
import { DisplayProps } from './types';

export const Display = ({
  level,
  children,
  className,
  ...restProps
}: DisplayProps): JSX.Element => {
  const HeadingElement = `h${level}` as 'h1' | 'h2';

  return (
    <HeadingElement className={cx(s.display, className)} {...restProps}>
      {children}
    </HeadingElement>
  );
};
